var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('kt-datatable',_vm._b({},'kt-datatable',_vm.datatableProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }